const ENTER_EXIT_TRANSITION_DURATION_MS = 300;
const wrapperCls = "_61w38qiwq";
const listCls = "_61lhsqmj3";
const itemCls = "_61i1j6vdy8";
const linkCls = "_61lmjmqse";
const itemIconCls = "_61iaofxbe";

export { ENTER_EXIT_TRANSITION_DURATION_MS, itemCls, itemIconCls, linkCls, listCls, wrapperCls };
import "./List.style.linaria.module.css";
//# sourceMappingURL=List.style.js.map
